// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2Akn0","row":"styles_row__1vsv3"};